<template>
    <div>
        <SOFilterBase
            v-if="isFilterOpen"
            @back="back()"
            @do-filter="doFilter"
            @reset-filter="resetFilter"
        >
            <template v-slot:filters>
                <div>
                    <SOFilterPeriode
                        :id="`filter-periode`"
                        :title="`Periode`"
                        :periode-transaksi="false"
                        :option-data="periode.data"
                        v-model="periode.selected"
                        :filter-global-key="periode.filterGlobalKey"
                        :keterangan="periode.keterangan"
                    />
                    <SOFilterCheckbox
                        id="pengulangan"
                        title="Pengulangan"
                        :items="filterOptions.pengulangan"
                        filter-name="jadwalPengulangan"
                    />
                    <SOFilterCheckbox
                        id="status-dijalankan"
                        title="Status Dijalankan"
                        :items="filterOptions.statusDijalankan"
                        filter-name="statusDijalankan"
                    />
                </div>
            </template>
        </SOFilterBase>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { moduleName } from "../store/state";

import SOFilterBase from "@/so-components/global/filter/base/SOFilterBase.vue";

import SOFilterPeriode from "@/so-components/global/filter/type/SOFilterPeriode.vue";
import SOFilterCheckbox from "@/so-components/global/filter/type/SOFilterCheckbox";

export default {
    name: "FilterInvoiceJadwal",
    components: {
        SOFilterBase,
        SOFilterPeriode,
        SOFilterCheckbox,
    },
    props: ['value'],
    data() {
        return {
            periode: {
                data: [
                    { id: "1", text: "Tanggal selanjutnya dijalankan" },
                    { id: "2", text: "Tanggal terakhir" },
                ],
                selected: "1",
                filterGlobalKey: "filter_periode_by",
                keterangan: "",
            },
            filterOptions: {
                pengulangan: [
                    {
                        id: 'pengulangan-1',
                        title: 'Bulanan',
                        value: 1,
                        checked: false,
                        titleBold: false,
                    },
                    {
                        id: 'pengulangan-2',
                        title: 'Mingguan',
                        value: 2,
                        checked: false,
                        titleBold: false,
                    }
                ],
                statusDijalankan: [
                    {
                        id: 'repeat-1',
                        title: 'Belum pernah',
                        value: 1,
                        checked: false,
                        titleBold: false,
                    },
                    {
                        id: 'repeat-2',
                        title: 'Berhasil',
                        value: 2,
                        checked: false,
                        titleBold: false,
                    },
                    {
                        id: 'repeat-3',
                        title: 'Gagal',
                        value: 3,
                        checked: false,
                        titleBold: false,
                    }
                ],
            },
        };
    },
    computed: {
        ...mapGetters("filterGlobalModule", {
            getFilterItem: "getFilterItem",
        }),
        isFilterOpen() {
            return this.value;
        },
        getFilterOptions() {
            return filterOptions;
        },
    },
    methods: {
        ...mapActions({
            resetPage: `${moduleName}/resetPage`,
            resetList: `${moduleName}/resetList`,
        }),
        back() {
            this.$emit('input', false);
        },
        async doFilter() {
            const filter = {
                end_Date: this.getFilterItem.periode.endDate,
                jenis_periode: this.getFilterItem.periode.filterBy,
                bulan: this.getFilterItem.periode.month,
                start_date: this.getFilterItem.periode.startDate,
                tahun: this.getFilterItem.periode.year,
                pengulangan: this.getFilterItem.jadwalPengulangan,
                status_dijalankan: this.getFilterItem.statusDijalankan,
                filter_periode_by: this.getFilterItem.filter_periode_by,
            }
            this.back();
            this.$emit('do-filter', filter);
        },
        async resetFilter() {
            await this.$store.commit("filterGlobalModule/resetFilterItem");
        },
    },
};
</script>
